<template>
  <v-sheet outlined class="pa-2">
    <v-row>
      <v-col cols="auto">
        <Tooltip content="Select device view from list" top>
          <v-combobox
            :items="deviceList"
            label="Search Device"
            v-model="device"
            dense
            prepend-icon="mdi-devices"
            outlined
            :disabled="manual"
            hide-details
          >
          </v-combobox>
        </Tooltip>
      </v-col>
      <v-spacer> </v-spacer>
      <v-col cols="auto">
        <h5 class="mt-5">Set manually</h5>
      </v-col>
      <v-col cols="auto">
        <v-switch v-model="manual" dense> </v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="auto">
        <h4 class="mb-2"><v-icon>mdi-cellphone-link</v-icon> Type:</h4>
        <v-row>
          <v-col cols="auto">
            <v-btn-toggle
              v-model="device.isMobile"
              group
              mandatory
              color="primary"
            >
              <Tooltip content="Desktop" top :active="manual">
                <v-btn :value="false" text :disabled="!manual" hide-details>
                  <v-icon>mdi-monitor</v-icon>
                </v-btn>
              </Tooltip>
              <!-- <Tooltip content="Tablet" top>
                <v-btn :value="true" text >
                  <v-icon>mdi-tablet</v-icon>
                </v-btn>
              </Tooltip> -->
              <Tooltip content="Mobile" top :active="manual">
                <v-btn :value="true" text :disabled="!manual" hide-details>
                  <v-icon>mdi-cellphone</v-icon>
                </v-btn>
              </Tooltip>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <h4 class="mb-2"><v-icon>mdi-arrow-all</v-icon> Dimentions:</h4>
        <v-row>
          <v-col>
            <v-text-field
              v-model="device.viewport.width"
              label="Width"
              prepend-icon="mdi-arrow-left-right"
              type="number"
              min="1"
              suffix="px"
              :disabled="!manual"
              @input="changed"
              outlined
              hide-details
              required
              dense
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="device.viewport.height"
              prepend-icon="mdi-arrow-up-down"
              :disabled="!manual"
              hide-details
              dense
              @input="changed"
              label="Height"
              type="number"
              suffix="px"
              min="1"
              outlined
              required
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script lang="ts">
import { DefaultDevice } from "@/defaults";
import { Device } from "@/types";
import Vue from "vue";
import VueTypes from "vue-types";
import Tooltip from "@/components/Tooltip.vue";

export default Vue.extend({
  name: "DeviceComp",

  data() {
    return {
      manual: false,
    };
  },
  components: {
    Tooltip,
  },
  props: {
    value: VueTypes.any.def(DefaultDevice),
  },
  methods: {
    changed() {
      // this.$emit("changed", this.device);
      this.$emit("input", this.device);
    },
  },
  computed: {
    deviceList() {
      const devices = this.$store.getters["Plans/getDeviceList"];
      return Object.keys(devices).map((device: string) => {
        return { text: device, value: device, ...devices[device] };
      });
    },
    device: {
      get(): Device {
        return this.value;
      },
      set(device: Device): void {
        this.$emit("input", { device });
      },
    },
  },
});
</script>
